<script setup lang="ts">
import { getItemMatchStatusLabel } from "@/stores/fileImport"
import { ItemMatchStatus } from "@/types"
import { computed } from "vue"

interface Props {
  /**
   * Status
   */
  status: ItemMatchStatus
}

const props = defineProps<Props>()

const isPending = computed(() => props.status === ItemMatchStatus.PENDING)

const statusColour = computed(() => {
  const ignoreStatus = [
    ItemMatchStatus.TO_IGNORE,
    ItemMatchStatus.ALREADY_IGNORED,
  ]
  const matchStatus = [
    ItemMatchStatus.CREATE,
    ItemMatchStatus.AUTO_MATCH,
    ItemMatchStatus.EXISTING_MATCH,
    ItemMatchStatus.MANUAL_MATCH,
    ItemMatchStatus.EDIT_MATCH,
  ]

  return {
    "bg-warmgray-300": ignoreStatus.includes(props.status),
    "bg-green-300": matchStatus.includes(props.status),
  }
})

const label = computed(() => {
  if (isPending.value) {
    return ""
  }
  return getItemMatchStatusLabel(props.status)
})
</script>

<template>
  <div class="flex items-center px-3">
    <div
      v-if="!isPending"
      class="mr-2 h-2 w-2 rounded-full"
      :class="statusColour"
    />
    {{ label }}
  </div>
</template>
